<template>
    <flex-element :element-type="elementType" class="f-inline-block" />
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    name: 'shape',
    mixins: [baseOrganism],
};
</script>
